import styled from "@emotion/styled";
export var MaskedLinkButton = /*#__PURE__*/ styled("button", {
    target: "e8bs6yp0"
})("background:none;border:none;padding:0;margin:0;cursor:pointer;color:inherit;text-decoration:inherit;display:inline;font-size:inherit;font-weight:inherit;");
